import { render, staticRenderFns } from "./navStepList2.vue?vue&type=template&id=c8bdacba&"
import script from "./navStepList2.vue?vue&type=script&lang=js&"
export * from "./navStepList2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports